import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Reveal from "../animations/Reveal";

function PlansSection() {
    const { t } = useTranslation();
    const photo_url = process.env.REACT_APP_SHANDE_PHOTO_URL;
    const plans = [
        {
            key: "sponsor",
            title: t("sponsorshipPlan"),
            desc: t("planSponsorDesc"),
            cta: t("planSponsorCta"),
            img: photo_url + "child_img/sponsor.png",
            to: "/sponsorshipPlan",
        },
        {
            key: "meal",
            title: t("lovelyMealPlan"),
            desc: t("planMealDesc"),
            cta: t("planMealCta"),
            img: photo_url + "lovely_meal_plan/lovely_lanscape.jpeg",
            to: "/lovelyMealPlan",
        },
        {
            key: "sales",
            title: t("charitySales"),
            desc: t("planSalesDesc"),
            cta: t("planSalesCta"),
            img: photo_url + "charity_sale/sales.jpg",
            to: "/charitySales",
        },
    ];
    return (
        <section className="landing-section landing-section-alt">
            <div className="container">
                <Reveal className="landing-plans-head">
                    <div>
                        <div className="landing-eyebrow">{t("ourProgramme")}</div>
                        <h2 className="landing-heading">{t("plansTitle")}</h2>
                    </div>
                    <p className="landing-section-desc">{t("plansDescription")}</p>
                </Reveal>
                <Reveal className="landing-plans-grid" stagger={0.15}>
                    {plans.map(plan => (
                        <div className="landing-plan-card" data-reveal key={plan.key}>
                            <img className="landing-plan-img" src={plan.img} alt={plan.title} />
                            <div className="landing-plan-body">
                                <h3 className="landing-plan-title">{plan.title}</h3>
                                <p className="landing-plan-desc">{plan.desc}</p>
                                <Link className="landing-plan-link" to={plan.to}>{plan.cta} →</Link>
                            </div>
                        </div>
                    ))}
                </Reveal>
            </div>
        </section>
    );
}
export default PlansSection;